module.exports = __webpack_public_path__ + "static/media/t_sk.dacc1761.pdf";